// ControlRadioButtonGroupFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import GroupModel    from 'GroupModel.js';
import RadioButtonControlView  from 'common-inputs/RadioButtonControlView.js';
import GroupControlView  from 'common-visuals/GroupControlView.js';
import listService from "../service/ListService";


//=============================================================================
//
// Creates a radio button group, given a factoryService parameter key and
// a layout position. The factory key defines the
// control appearance through its template..
//
// -Maty Rocha, February 22, 2015
//
//=============================================================================
class ControlRadioButtonGroupFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {
        const attributes = this.createChildAttributes( factoryKey, pos ) ;
        const height = attributes.height;
        const width = attributes.width;
        const groupTabIndex = attributes.tabIndex;

        attributes.silent = false;

        //var id1 = sequenceService.nextDomId();

        // no need to generate new IDs for existing loaded items.
        var id2 = pos && pos.loading ? '' : sequenceService.nextDomId();
        var id3 = pos && pos.loading ? '' : sequenceService.nextDomId();
        var groupId = pos && pos.id ? pos.id : sequenceService.nextDomId();

        sequenceService.tabIndexParentId = groupId;
        //adding silent(accessibility) to attributes.
        attributes.family = constants.CONTROL_COMMON_INPUTS;
        attributes.icon = 'pf-radio-button';
        attributes.name = 'Radio Button';
        attributes.width = '106px';
        attributes.height = "18px";
        attributes.styleColorText ='~selectionTextColor';
        attributes.styleColorTextOver ='~selectionTextOverColor';
        attributes.fontFamily = '~selectionFont';
        attributes.fontSize = '~selectionFont';
        attributes.textWeight = '~selectionFont';
        attributes.textStyle  = '~selectionFont';
        attributes.borderColor = '~groupBorderColor';
        attributes.backgroundColor = '~groupBgColor';
        attributes.advancedBgGradientColor = '~selectionBgGradientColor';
        attributes.factoryKey = 'control_radio_button';
        attributes.value = '1';
        attributes.text = 'Option 1';
        attributes.name = 'Radio Button 1';
        attributes.checked = '';
        attributes.pos = {top : 20, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.inlineEditable = true;
        attributes.selected = true;
		attributes.minWidth = 15;
        attributes.minHeight = 17;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = true;
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"}
        ];

        const radioButtonModel1 = new ControlModel( attributes );

        /*
        const radioView1 = new RadioButtonControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_radio_button', id: id1} );
        radioView1.groupId = groupId;
        */

        attributes.value = '2';
        attributes.name = 'Radio Button 2';
        attributes.text = 'Option 2';
        attributes.selected = false;
        attributes.pos = {top : 60, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.id = id2;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = true;

        const radioButtonModel2 = new ControlModel( attributes );

        /*
        const radioView2 = new RadioButtonControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_radio_button', id: id2} );
        radioView2.groupId = groupId;
        */

        attributes.value = '3';
        attributes.name = 'Radio Button 3';
        attributes.text = 'Option 3';
        attributes.selected = false;
        attributes.pos = {top : 100, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.id = id3;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = true;

        const radioButtonModel3 = new ControlModel( attributes );

        //  Don't count these radio buttons. They already have their own group and value
        sequenceService.removeRadioButtons(3);
        /*
        const radioView3 = new RadioButtonControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_radio_button', id: id3} );
        radioView3.groupId = groupId;
        */

        // attributes for header
        attributes.factoryKey = factoryKey;
        attributes.icon = 'pf-radio-button-group';
        attributes.titleColor ='~groupTextColor';
        attributes.titleFontFamily = '~groupFont';
        attributes.titleFontSize = '~groupFont';
        attributes.titleTextWeight = '~groupFont';
        attributes.titleTextStyle  = '~groupFont';
        attributes.showGroupHeader = 'hide';
        attributes.alignLeftSelection = 'lightgrey';
        attributes.alignCenterSelection = 'transparent';
        attributes.alignRightSelection = 'transparent';
        attributes.titleBackgroundColor = '~groupTitleBg';
        attributes.hasTitle = 'false';
        attributes.titleText = 'Group';
        attributes.titleHeight = '25';
        attributes.titleAlign ='left';
        // attributes for group
        attributes.name = 'Radio Button Group';
        attributes.borderStyle= '~groupBorder';
        attributes.borderSize= '~groupBorder';
        attributes.cornerRadius= '~groupBorder';
        attributes.borderColor = '~groupBorderColor';
        attributes.styleBGColorText = '~groupBgColor';
        attributes.bgImage = '~groupBgImage';
        attributes.transparentBackground = '~groupBgTransparent';
        attributes.backgroundImageAssetId = '~groupBgImage';
        attributes.titleBoldSelection = 'transparent';
        attributes.titleItalicSelection = 'transparent';
        attributes.groupBackgroundImageTag = '';
        attributes.groupBackgroundImageStyle = '';

        attributes.top = (listService.mainKind === constants.KIND_MOBILE || !pos) ? '' : pos.top;
        attributes.left = (listService.mainKind === constants.KIND_MOBILE || !pos) ? '' : pos.left;
        attributes.width = width;
        attributes.height = height;
        attributes.tabIndex = groupTabIndex;

        attributes.childList = [radioButtonModel1, radioButtonModel2, radioButtonModel3];
        attributes.translateProps = [
            {key:"titleText", label:"Title Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const groupView = new GroupControlView( { model: new GroupModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: groupId} );

        return groupView;
    }

}

const controlRadioButtonGroupFactory = new ControlRadioButtonGroupFactory();

export default controlRadioButtonGroupFactory;
